import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class MaterialCategories extends AbstractController {
    protected controllerName = 'MaterialCategories';
}
